import { render, staticRenderFns } from "./PurchaseOptionHeader.vue?vue&type=template&id=10428861&"
import script from "./PurchaseOptionHeader.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOptionHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports